import { render, staticRenderFns } from "./elUploadsChoice.vue?vue&type=template&id=6e9c8c61&scoped=true"
import script from "./elUploadsChoice.vue?vue&type=script&lang=js"
export * from "./elUploadsChoice.vue?vue&type=script&lang=js"
import style0 from "./elUploadsChoice.vue?vue&type=style&index=0&id=6e9c8c61&prod&lang=less&scoped=true"
import style1 from "./elUploadsChoice.vue?vue&type=style&index=1&id=6e9c8c61&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9c8c61",
  null
  
)

export default component.exports